module.exports = __webpack_public_path__ + "static/media/dining-room.c70d6226.svg";